<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br_filter {
    color: rgba(109, 103, 164);
}

.br_spacer {
    padding-top: 10px;
}

</style>

<template>
<div>
    <v-toolbar flat>
        <v-toolbar-title><h2 class="br">PPPoE IPv4 subscribers</h2></v-toolbar-title>
    </v-toolbar>

    <v-container>
        <v-row>
            <v-col cols="12">
                <h3 class="br_filter">Filter</h3>
                <v-text-field v-model="f_svid"
                    label="SVID" single-line hide-details
                ></v-text-field>
                <v-text-field v-model="f_cvid"
                    label="CVID" single-line hide-details
                ></v-text-field>
                <div class="br_spacer">

                </div>
                <v-btn color="primary" dark class="mb-2" @click="filter_items">
                    Filter
                </v-btn>
            </v-col>
        </v-row>
    </v-container>

    <v-data-table
        :headers="headers"
        :items="filtered_items"
        :search="search"
        sort-by="id"
        class="elevation-1"
        @dblclick:row="on_dbl_click">

    <template v-slot:top>
        <v-dialog v-model="dialog" max-width="600px">

            <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card>
                <v-card-title>
                    <span class="headline">{{ edit_caption }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container style="height: 520px; overflow-y: scroll;">
                        <v-row>

                    <v-col cols="12">
                        <v-btn v-if="edited_index !== -1" color="blue darken-2"
                            text @click="disconnect">Disconnect
                        </v-btn>

                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.id"
                            label="ID"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.username"
                            label="Username"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.mac"
                            label="MAC"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.port_id"
                            label="Port"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.svid"
                            label="SVID"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.cvid"
                            label="CVID"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.peer_ip_addr"
                            label="IP"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.mtu"
                            label="MTU"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.ingress_shaper"
                            label="Ingress Qdisc"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.egress_shaper"
                            label="Egress Qdisc"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.rxp"
                            label="RX pkts"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.txp"
                            label="TX pkts"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.rxb"
                            label="RX bytes"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.txb"
                            label="TX bytes"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.connected_at"
                            label="Connected at"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.uptime"
                            label="Uptime"
                        ></v-text-field>
                    </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="edited_index !== -1" color="blue darken-1"
                        text @click="close">Close
                    </v-btn>
                </v-card-actions>
            </v-card></ValidationObserver>

        </v-dialog>

        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small class="me-2" @click="edit_item(item)">
            mdi-pencil
        </v-icon>
    </template>

    <template v-slot:no-data>
        no records found
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js";

export default {
name: "pppoe_ipv4_subsc",
components: { 
    Treeselect, ValidationProvider, ValidationObserver,
},
data: () => ({
    f_svid: '',
    f_cvid: '',

    edit_caption: '',
    search: '',
    dialog: false,

    headers: [
        { text: 'Id', value: 'id', align: 'start' },
        { text: 'Username', value: 'username' },
        { text: 'MAC', value: 'mac' },
        { text: 'Port', value: 'port_id' },
        { text: 'SVID', value: 'svid' },
        { text: 'CVID', value: 'cvid' },
        { text: 'IP', value: 'peer_ip_addr' },
        { text: 'MTU', value: 'mtu' },
        { text: 'Ingress Qdisc', value: 'ingress_shaper' },
        { text: 'Egress Qdisc', value: 'egress_shaper' },
        { text: 'RX pkts', value: 'rxp' },
        { text: 'TX pkts', value: 'txp' },
        { text: 'RX bytes', value: 'rxb' },
        { text: 'TX bytes', value: 'txb' },
        { text: 'Uptime', value: 'uptime', width: '300px' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],

    items: [],
    filter_prms: {},
    filtered_items: [],
    edited_index: -1,
    edited_item: {
    },
}),

created() {
    this.initialize()
},

methods: {
    filter_items() {
        this.filter_prms['svid'] = this.f_svid.trim();
        this.filter_prms['cvid'] = this.f_cvid.trim();

        this.filtered_items = this.items.filter((i) => {
            if (this.filter_prms.svid != '' && i.svid != this.filter_prms.svid)
                return false; 
            if (this.filter_prms.cvid != '' && i.cvid != this.filter_prms.cvid)
                return false; 
            return true;
        });
    },

    initialize() {
        return new Promise((resolve, reject) => {
            api_client.run_get_query('/pppoe/ipv4_subsc')
            .then(response => {
                this.items = response.data;
                this.filter_items();
                resolve(response);
            })
            .catch(error => {
                console.log(error);
            });
        });
    },

    edit_item(item) {
        this.edited_index = this.filtered_items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.edit_caption = 'PPPoE IPv4 subscriber';
        this.dialog = true;
    },

    on_dbl_click(event, data) {
        this.edit_item(data.item);
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    disconnect() {
        this.$confirm("Are you sure you want to disconnect PPPoE subscriber with username '" + 
            this.edited_item.username + "', id " + this.edited_item.id + " ?")
        .then(() => {
            this.disconnect_act()
        });
    },

    disconnect_act() {
        api_client.run_post_query("/pppoe/disconnect", {
            id: this.edited_item.id
        })
        .then(response => {
            this.filtered_items.splice(this.edited_index, 1);
            this.close();
        })
        .catch(error => {
            console.log(error);
        });
    },
}

};
</script>
